<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useWishlist } from '@/Composables/wishlist'
import { ProductVariant } from '@interfaces/product.interface'
import { HeartIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
    productVariant: ProductVariant,
}>()

const { t } = useI18n()
const wishlist = useWishlist(props.productVariant)
</script>

<template>
    <button class="flex items-center justify-center px-3 border rounded text-grayscale-800 border-grayscale-100 group" @click="wishlist.syncWishlist">
        <HeartIcon class="w-6 h-6 transition stroke-[1.25] group-hover:scale-[1.20]" :class="[wishlist.added.value ? 'fill-red-600 stroke-red-600' : 'fill-none stroke-current group-hover:stroke-error-600 group-hover:fill-error-50']" />
        <span class="sr-only">{{ wishlist.added.value ? t('components.product.added-to-wishlist') : t('components.product.add-to-wishlist') }}</span>
    </button>
</template>
